import { ButtonGroup } from "react-bootstrap";
import Backdrop from "@mui/material/Backdrop";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

export default function ModeSelectionPrompt(props) {
  let side = 0;
  let mode = "new";

  function setSide(value) {
    if (value !== side) {
      side = value;
    }
  }

  function setMode(value) {
    if (value !== mode) {
      mode = value;
    }
  }

  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={props.viewBackdrop}
    >
      <ButtonGroup
        id="ButtonGroup"
        variant="contained"
        className="selection-group"
        aria-label="outlined primary button group"
        style={{ display: "none" }}
      >
        <div className="quiz-text">Vyberte si režimy</div>
        <br></br>
        <FormControl fullWidth>
          <Select
            className="select-display-text"
            defaultValue={side}
            onChange={(e) => setSide(e.target.value)}
          >
            <MenuItem value={0}>Obe uši</MenuItem>
            <MenuItem value={1}>Ľavé ucho</MenuItem>
            <MenuItem value={2}>Pravé ucho</MenuItem>
            <MenuItem value={3}>Náhodne</MenuItem>
          </Select>
        </FormControl>
        <br></br>
        <FormControl fullWidth>
          <Select
            className="select-display-text"
            defaultValue={mode}
            onChange={(e) => setMode(e.target.value)}
          >
            <MenuItem value="new">Zvieratká</MenuItem>
            <MenuItem value="old">Rôzne</MenuItem>
          </Select>
        </FormControl>
        <br></br>
        <Button
          variant="contained"
          className="selection-button"
          onClick={() => {
            props.historyPush({
              pathname: "/test",
              state: { side: side, mode: mode },
            });
          }}
        >
          Potvrdiť
        </Button>
        <Button
          variant="contained"
          className="selection-button"
          id="selection-button-red"
          onClick={() => {
            props.hide("ButtonGroup");
            props.handleToggle();
          }}
        >
          Zavrieť
        </Button>
      </ButtonGroup>
    </Backdrop>
  );
}
